<!-- eslint-disable -->
<div class="bet" *ngFor="let result of ticket?.betHistoryInfo">
  <div class="bet-card" tappable="true" (click)="openBetDetail(result.TicketNumber, result)">
    <div class="bet-card-header">
      <!-- Tipo de apuesta: siempre, acumulada... -->
      <span class="header-type" text-left>
        {{'tApues'|translate}} {{result.BetType}} (<span *ngIf="result.BetTypeNumber!='1'">{{result.X}}</span>
        <span *ngIf="result.X!=result.Y || result.BetTypeNumber=='1'">
          <span *ngIf="result.BetTypeNumber!='1'">/</span>
          <span>{{result.Y}}</span> </span
        >)
        <img *ngIf="!!result.VoucherCode" class="freebet-img" src="assets/global/img/logobue.png" alt="" />
      </span>

      <!-- estado de la apuesta: abierta, perdida, ganada...-->
      <span class="header-status" text-right>
        <b
          [ngClass]="{
                      'color-dark': result.TicketStatusNumber === '0',
                      'color-primary': result.TicketStatusNumber === '5' || result.TicketStatusNumber === '1',
                      'color-alert': result.TicketStatusNumber === '3',
                      'color-secondary': result.TicketStatusNumber === '4'
                      }"
        >
          {{result.TicketStatus | uppercase}}
        </b>
      </span>
    </div>

    <div class="bet-card-info">
      <h3 class="eventSport">{{result?.betEvents[0]?.SportName}} - {{result.betEvents[0]?.LeagueName}}</h3>
      <p class="eventAp">{{result.betEvents[0]?.EventName.split('-')[0] | sportsFormatTitleEvent}}</p>
      <p class="eventAp" *ngIf="!!result.betEvents[0]?.EventName.split('-')[1]">
        {{result.betEvents[0]?.EventName.split('-')[1] | sportsFormatTitleEvent}}
      </p>
      <p class="eventWinner" text-left>
        {{result?.betEvents[0]?.MarketName}}
        <span>({{result?.betEvents[0]?.ResultName}})</span>
      </p>
    </div>
    <div class="bet-card-money">
      <div class="bet-card-money-item">
        <h5 class="pretitle">{{'tImp' | translate}}</h5>
        <p class="title">{{result?.Stake | sportsParseMoney}}</p>
      </div>
      <div class="bet-card-money-item">
        <h5 class="pretitle">{{'bolC' | translate}}</h5>
        <p ng-show="" class="title">
          {{ (!result?.VoucherCode? result?.PotentialWinnings/result.Stake :
          result?.PotentialWinningsOriginal/result.Stake).toString() | sportsFormatOdd }}
        </p>
      </div>
      <div class="bet-card-money-item">
        <h5 class="pretitle">{{'compapuestaP2' | translate}}</h5>
        <p class="title">{{result?.PotentialWinnings | sportsParseMoney}}</p>
      </div>
      <button
        ion-button
        full
        class="blueBt"
        (click)="payOutTicket(result?.TicketNumber,result)"
        *ngIf="(globalVars?.FEATURES?.EarlyCashoutEnabled && globalVars?.user?.logged && result?.TicketStatusNumber=='4' && checkStatusCode(result,0) && !result?.VoucherCode)"
      >
        {{'Cobraryabtn' | translate}} {{ result?.Amount/100 | sportsParseMoney}}!
      </button>
    </div>

    <div class="arrow codere-icon">
      <i item-right class="arrow codere-icon"></i>
    </div>
  </div>

  <!-- todo: revisar -->
  <div class="bet-detail" *ngIf="!!result.show">
    <div class="bet-detail"></div>
    <ion-grid no-padding margin-bottom>
      <ion-row class="row-wrap">
        <ion-col col-6 col-sm-6 col-md-12 no-padding>
          <p class="resume-item">
            {{'compapuestaP1' | translate}}
            <span class="align-right">{{result?.Stake}}</span>
          </p>

          <p
            *ngIf="globalVars.licenseType !== 4 && result?.PotentialWinningsOriginal !== result?.PotentialWinnings && !result?.VoucherCode"
            class="resume-item"
          >
            <span> {{'v2_mejTuPremSinmej' | translate}} </span>
            <span class="align-right">{{result?.PotentialWinningsOriginal | sportsParseMoney}}</span>
          </p>
          <p class="resume-item">
            <span *ngIf="result?.TicketStatusNumber === '1' || result?.TicketStatusNumber === '5'">
              {{'hDetailsGan' | translate}}
            </span>
            <span
              *ngIf="(result?.TicketStatusNumber !== '1' && result?.TicketStatusNumber !== '5') && (result?.PotentialWinningsOriginal !== result?.PotentialWinnings && !result?.VoucherCode && globalVars.licenseType !== 4)"
            >
              {{'v2_mejTuPremConmej' | translate}}
            </span>
            <span
              *ngIf="(result?.TicketStatusNumber !== '1' && result?.TicketStatusNumber !== '5') && (result?.PotentialWinningsOriginal === result?.PotentialWinnings || (result?.PotentialWinningsOriginal !== result?.PotentialWinnings && !!result?.VoucherCode) || (result?.PotentialWinningsOriginal !== result?.PotentialWinnings && globalVars.licenseType === 4))"
            >
              {{'compapuestaP2' | translate}}
            </span>
            <span class="align-right">{{result?.PotentialWinnings | sportsParseMoney}}</span>
          </p>
        </ion-col>
        <ion-col col-6 col-sm-6 col-md-12 no-padding>
          <p class="resume-item">
            {{'hDetailsApu' | translate}}
            <span class="align-right">{{result?.TicketDatetime | sportsExtractDate:[2]}}</span>
          </p>
          <p class="resume-item">
            {{'nticket' | translate}}
            <span class="align-right">{{result?.TicketNumber}}</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- Mostrar detalle: PASAR A COMPONENTE -->
    <div class="bet-card has-shadow no-padding" *ngFor="let event of result.betEvents" no-padding>
      <h3 class="eventSport">{{event?.LeagueName}}</h3>
      <p class="eventAp">{{event?.EventName.split('-')[0]}}</p>
      <p class="eventAp" *ngIf="!!event?.EventName.split('-')[1]">{{event?.EventName.split('-')[1]}}</p>
      <p class="eventSport">{{event?.MarketName}}</p>

      <p
        class="eventWinner"
        [attr.text-right]="isMobile ? '': null"
        [ngClass]="{
                     'color-dark': event?.ClearingStatusNumber === '0',
                     'color-primary': event?.ClearingStatusNumber === '5' || event?.ClearingStatusNumber === '1',
                     'color-secondary': event?.ClearingStatusNumber === '3' || event?.ClearingStatusNumber === '4'}"
      >
        {{event?.ResultName}} - {{'bolC' | translate}} {{event?.Odd.toString() | sportsFormatOdd}}
      </p>
      <div class="bet-detail-status">
        <p
          [ngClass]="{
          'color-dark': event?.ClearingStatusNumber === '0',
          'color-primary': event?.ClearingStatusNumber === '5' || event?.ClearingStatusNumber === '1',
          'color-secondary': event?.ClearingStatusNumber === '3' || event?.ClearingStatusNumber === '4'}"
        >
          <i class="icon-multi color-secondary" *ngIf="event?.IsBank"></i>
          {{event?.ClearingStatus | uppercase}}
        </p>
        <p>{{event?.EventDatetime | sportsExtractDate:[2]}}</p>
      </div>
    </div>

    <!-- <div class="loadSpinner" *ngIf="result?.loading">
              <ion-spinner name="dots"></ion-spinner>
          </div> -->
    <div class="legal" *ngIf="globalVars.licenseType === 1">
      <span [innerHTML]="'textHistLicen'| translate"></span>
      <br />
      <!--Apuesta de contrapartida. Codere Online S.A.U. - CIF: A-80346038 - Inscripci?n: AP-000001-->
      <span [innerHTML]="'testBootomTicket' | translate"></span>
      <!--Las normas de organizaci?n y funcionamiento que rigen la apuesta se encuentran a su disposici?n en la p?gina <a href="http://www.codere.es" tarjet="_blank">http://www.codere.es</a>-->
    </div>
    <div class="legal" *ngIf="globalVars.licenseType === 0">
      <span [innerHTML]="'textBetLicenNac' | translate"></span>
      <!--Apuesta de contrapartida. Codere Online S.A.U. - CIF: A-80346038 - Inscripci?n: AP-000001-->
      <span>
        - CIF: A-80346038 - con las siguientes licencias: 225-11/GA/A86346038/SGR, AOC/2014/002, ADC/2014/001,
        AHC/2014/002</span
      >
      <br />
      <span [innerHTML]="'testBootomTicket' | translate"></span>
      <!--Las normas de organizaci?n y funcionamiento que rigen la apuesta se encuentran a su disposici?n en la p?gina <a href="http://www.codere.es" tarjet="_blank">http://www.codere.es</a>-->
    </div>
  </div>
</div>
